var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reg-text-notice"},[_vm._v("\n    Ваш e-mail подтвержден. Теперь Вы можете\n    "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("войти")]),_vm._v("\n    в веб интерфейс управления и использовать его для\n    авторизации в приложении.\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }